import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Buttons } from 'lidya-common-components';
import team from './getTeam';

import './who.our.team.less';
import { COUNTRY_LANGUAGE_LIST } from '../../common/webSiteLanguages';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

const getCountryFromFolder = (fileName) => {
  const folder = fileName.split('/')[0];
  const country = folder.split('_')[1];
  return country;
};

const ImageComponent = ({ p }) => {
  const { t } = useTranslation();
  const country = getCountryFromFolder(p.node.relativePath);
  const translatedCountry = t(`ct_${country}`);
  return (
    <div className="m-whoOurTeam__teamIndividual">
      <GatsbyImage
        image={getImage(p.node)}
        className="a-whoOurTeam__avatar"
        alt={t('images.team.member.alt', { country: translatedCountry })}
        title={t('images.team.member.title')}
      />
    </div>
  );
};

const OurTeam = () => {
  const { country } = useGlobalData();
  const getSortedList = useMemo(() => {
    const teamList = team();
    if (country === COUNTRY_LANGUAGE_LIST.us.code) {
      return teamList.sort(() => 0.5 - Math.random());
    }
    const nTeamList = teamList.sort((a, b) => {
      const aPositionPath = a.node.relativePath.split(/_(.+)/)[1];
      const bPositionPath = b.node.relativePath.split(/_(.+)/)[1];
      if (
        aPositionPath.startsWith(country) === bPositionPath.startsWith(country)
      ) {
        return a.node.relativePath.localeCompare(b.node.relativePath);
      }
      return aPositionPath.startsWith(country) ? -1 : 1;
    });
    return nTeamList || [];
  }, [country]);

  return (
    <div className="o-whoOurTeam">
      <div className="m-globalContentContainer -block">
        <div className="m-whoOurTeam__titleContainer">
          <h1 className="a-whoOurTeam__title -page-title">
            <Trans>web.about.who.our.team.title</Trans>
          </h1>
        </div>
        <h2 className="a-whoOurTeam__subTitleTop">
          <Trans>web.about.who.our.team.sub.title</Trans>
        </h2>
        <div className="m-whoOurTeam__showReadmore">
          <input
            type="checkbox"
            className="a-whoOurTeam__expand-toggle"
            id="section1-toggle"
          />

          <div className="m-whoOurTeam__teamContainer">
            {getSortedList.map((person, index) => (
              <ImageComponent p={person} key={index} />
            ))}
            <div className="a-whoOurTeam__overlay" />
          </div>
          <div className="m-whoOurTeam__expandable-action-area">
            <Buttons.Button type={Buttons.BUTTON_TYPES.TERTIARY}>
              <label
                htmlFor="section1-toggle"
                className="a-whoOurTeam__expand-toggle-label"
              >
                <Trans>web.about.who.our.team.see.more</Trans>
              </label>
            </Buttons.Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
